import DOMPurify from 'dompurify';
import { some, startsWith, toLower } from 'lodash';
import { ALLOWED_TARGET_LINKS } from '@trip-ux/constants';

export const sanitizeDOM = (val: string): string => {
  return DOMPurify.sanitize(val, { 
    ADD_ATTR: ['target'],
    FORBID_ATTR: ['style'] // Prevent inline styles to comply with CSP
  });
};

export const configureDomPurify = (contextPath: string, ariaLabel?: string): void => {
  DOMPurify.addHook('afterSanitizeAttributes', node => {
    const tag = toLower(node.tagName);

    if (tag === 'a') {
      const target = node.getAttribute('target');
      const href = node.getAttribute('href');
      const textContent = node.textContent;

      if (some([contextPath, ...ALLOWED_TARGET_LINKS], link => startsWith(href, link))) {
        node.setAttribute('rel', 'noopener');
      } else {
        if (target) {
          node.removeAttribute('target');
        }
        node.setAttribute('rel', 'noopener noreferrer');
      }

      const currentTarget = node.getAttribute('target');
      if (currentTarget && currentTarget === '_blank' && ariaLabel) {
        node.setAttribute('aria-label', `${textContent} (${ariaLabel})`);
      }
    }
  });
};
